// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".externa_left-leave-to,.externa_right-enter{transform:translate3d(100vw,0,0)!important}.externa_left-enter-to,.externa_left-leave,.externa_right-enter-to,.externa_right-leave{transform:none}.externa_left-enter,.externa_right-leave-to{transform:translate3d(-100vw,0,0)!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
